import React from "react";
import Header from "../components/Header";
import Form from "../components/Form";

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <Form />
    </div>
  );
};

export default Home;
